import { PropsWithChildren } from "react";
import { withLDProvider } from "launchdarkly-react-client-sdk";
import { INITIAL_CONTEXT } from "@/integrations/launch-darkly/index";

export const LaunchDarklyProvider = withLDProvider<PropsWithChildren>({
  clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID,
  context: INITIAL_CONTEXT,
  options: {
    bootstrap: "localStorage",
  },
})(({ children }) => {
  return children;
});
